import { Squid, type SquidItemProps, Text } from "@sequoiacap/client-ui";
import Image from "next/image";
import styles from "./SquidChildWithImage.module.scss";

const staticLoader = ({ src }: { src: string }) => src;

type SquidChildWithImageProps = Omit<SquidItemProps, "children"> & {
  type?: string;
  name?: string;
  meta?: string;
  backgroundImageURL: string;
};

export function SquidChildWithImage(
  props: SquidChildWithImageProps,
): JSX.Element {
  const { type, name, meta, backgroundImageURL, ...rest } = props;
  return (
    <Squid.Item {...rest}>
      <div className={styles.container}>
        <Image
          loader={staticLoader}
          src={backgroundImageURL}
          className={styles.bgImg}
          alt={name || ""}
          fill
        />
        <div className={styles.content}>
          {props.type && (
            <Text as="div" variant="label1" className={styles.type}>
              {type}
            </Text>
          )}
          {props.name && (
            <Text as="div" variant="subheader3" className={styles.name}>
              {name}
            </Text>
          )}
          {props.meta && (
            <Text as="div" variant="body3Sans" className={styles.meta}>
              {meta}
            </Text>
          )}
        </div>
      </div>
    </Squid.Item>
  );
}
